import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography } from 'antd';
import useQuery from 'hooks/useQuery';
import { getCancelarRestablecerPassword } from 'api/usuarios/auth';

const { Text } = Typography;

const CancelarRestablecerContrasena = () => {
  const navigate = useNavigate();
  const codigo = useQuery(['codigo']);
  const [respuesta, setRespuesta] = useState('Obteniendo respuesta...');

  if (!codigo) {
    navigate('/inicio-de-sesion');
  }

  useEffect(() => {
    const verify = async () => {
      const canceled = await getCancelarRestablecerPassword(codigo);
      if (canceled) {
        setRespuesta('Se canceló con exito la petición para restablecer la contraseña.');
      } else {
        setRespuesta('Lo sentimos. Ha ocurrido un proceso inesperado, vuelva a intentarlo.');
      }
    };
    verify();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Text style={{ textAlign: 'center' }}>
        {respuesta}
      </Text>
      <br />
      <Button
        className="auth-submit-button"
        style={{
          width: '150px',
        }}
        onClick={() => navigate('/inicio-de-sesion')}
      >
        Continuar
      </Button>
    </>
  );
};

export default CancelarRestablecerContrasena;
